import gql from "graphql-tag";

export const assetTypeDetailsFragment = gql`
  fragment AssetTypeDetails on AssetType {
    id
    createdAt
    updatedAt
    data
    type
    nft
  }
`;

export const assetDetailsFragment = gql`
  fragment AssetDetails on Asset {
    id
    createdAt
    updatedAt
    value
    type {
      ...AssetTypeDetails
    }
  }
`;

export const partDetailsFragment = gql`
  fragment PartDetails on Part {
    id
    createdAt
    updatedAt
    account
    value
  }
`;

export const orderDataDetailsFragment = gql`
  fragment OrderDataDetails on OrderData {
    id
    createdAt
    updatedAt
    originFees {
      ...PartDetails
    }
    payouts {
      ...PartDetails
    }
  }
`;

export const orderDetailsFragment = gql`
  fragment OrderDetails on Order {
    id
    createdAt
    updatedAt
    start
    end
    hash
    make {
      ...AssetDetails
    }
    take {
      ...AssetDetails
    }
    maker
    taker
    orderData {
      ...OrderDataDetails
    }
    salt
    signature
  }
`;
